import { render, staticRenderFns } from "./vendor_report.vue?vue&type=template&id=0a7d6137"
import script from "./vendor_report.vue?vue&type=script&lang=js"
export * from "./vendor_report.vue?vue&type=script&lang=js"
import style0 from "./vendor_report.vue?vue&type=style&index=0&id=0a7d6137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports